import { isArray } from 'lodash'
import { Path, UseFormReturn } from 'react-hook-form'

export const capitalizeFirstLetter = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export const lowerFirstLetter = (text: string): string => {
  return text.charAt(0).toLowerCase() + text.slice(1)
}

export const validateOnBlur = async <T>(name: Path<T> | Array<Path<T>>, field: any, form: UseFormReturn<any>) => {
  field.onBlur()
  if (typeof name === 'string') {
    await form.trigger(name)
  }
  if (isArray(name)) {
    name.forEach(async (item) => {
      await form.trigger(item)
    })
  }
}

export function deepParseJSON(value: string): unknown {
  try {
    // Handle basic JSON parsing
    const parsed = JSON.parse(value)

    // If parsed result is not an object or array, return as is
    if (typeof parsed !== 'object' || parsed === null) {
      return parsed
    }

    // Handle nested stringified objects/arrays
    const processValue = (item: any): any => {
      if (typeof item !== 'string') {
        // If it's an array, process each element
        if (Array.isArray(item)) {
          return item.map((element) => processValue(element))
        }
        // If it's an object, process each property
        if (typeof item === 'object' && item !== null) {
          return Object.fromEntries(Object.entries(item).map(([key, val]) => [key, processValue(val)]))
        }
        return item
      }

      // Try to parse string values that might be stringified objects
      try {
        const innerParsed = JSON.parse(item)
        // Only recurse if we actually parsed an object/array
        if (typeof innerParsed === 'object' && innerParsed !== null) {
          return processValue(innerParsed)
        }
        return innerParsed
      } catch {
        // If parsing fails, return original string
        return item
      }
    }

    return processValue(parsed)
  } catch (error) {
    // If initial parsing fails, return the original value
    return value
  }
}
